import {useEffect, useState} from 'react';

export const useResults = (state) => {
  const [message, setMessage] = useState('');
  const [results, setResults] = useState({});
  const [fallback, setFallback] = useState('');
  const {data, score} = state;
  const {result} = data;

  useEffect(() => {
    if (score.group === undefined || Object.keys(score.group).length === 0) return null;

    const groupResults = result?.filter((item) => {
      if (item.values) {
        return item;
      }

      setFallback(item['fallback_text']);
    });

    setResults(
      Array.isArray(groupResults) && groupResults?.find((item) => {
        const resultValues = item.values?.filter((el) => {
          if (item['use_totals']) {
            return score.group[el.group] >= Number(el.min)
              && score.group[el.group] <= Number(el.max)
              && score.total >= Number(item['total_min'])
              && score.total <= Number(item['total_max']);
          }
          else {
            return score.group[el.group] >= Number(el.min)
              && score.group[el.group] <= Number(el.max);
          }
        });

        if (resultValues.length === Object.keys(score.group).length) {
          return item;
        }
      })
    );

  }, [score, result]);

  useEffect(() => {
    if (results !== undefined && Object.keys(results).length > 0) {
      return setMessage(results.text);
    }

    if (results === undefined) {
      return setMessage(fallback);
    }
  }, [results]);

  return message;
};
